import React from 'react';
import { Text } from '@adobe/react-spectrum';
import { PlatformType } from 'app/views/components/dialogs/publish/platform';
import { PublishWell as DefaultPublishWell } from '../common/PublishWell';
export const PublishWell = () => (React.createElement(DefaultPublishWell, { platform: PlatformType.AdobeCloud },
    React.createElement(Text, null,
        "Image will be published in ",
        React.createElement("b", null, "Annotely"),
        " library on your",
        ' ',
        React.createElement("b", null, "Adobe Cloud"))));
